import type DispatchFilterStatus from "./DispatchFilterStatus";

export const DispatchStatusQueryParamName = "ds";

export type DispatchStatusQueryParam = DispatchFilterStatus | string;

export interface IDispatchStatusContext {
    dispatchStatus?: DispatchStatusQueryParam;
}